export const ADMIN_PATH = '/admin';
export const APPOINTMENTS_PATH = '/appointments';
export const BARBER_PATH = '/barber';
export const BRAND_PATH = '/brand';
export const CHANGE_PASSWORD_BRAND_PATH = '/brand/settings/change-password';
export const LOYALTY_BRAND_PATH = '/brand/discounts/loyalty-program';
export const PROMOS_BRAND_PATH = '/brand/discounts/promo';
export const DASHBOARD_RELATIVE_PATH = 'dashboard/v2';
export const SALES_RELATIVE_PATH = 'sales/v2';
export const LOGIN_PATH = '/login';
export const FBE_LOGIN_PATH = '/fbe-login';
export const ROOT_PATH = '/';
